import React, { useContext } from 'react'
import styled from '@emotion/styled'
import moment from 'moment'
import { colors } from 'style/theme'
import TimeAgo from 'react-timeago'
import { Button, Icon } from 'antd'
import { DomainsContext } from 'views/Administration/Account/AccountDomains'
import { toLocalTime } from 'utils/formatters'

const Actions = styled.div({
  display: 'flex'
})

const ActionsButtons = styled.div({
  marginLeft: 'auto'
})

const StyledCol = styled.span({
  fontWeight: 700,
  fontSize: 14
})

const StyledDate = styled(StyledCol)({
  color: colors.brandTextLight
})

function DomainListColumns() {
  const { onEdit, onDelete } = useContext(DomainsContext)
  return [
    {
      title: 'DOMAIN',
      dataIndex: 'domain',
      sorter: (a, b) => a.domain.localeCompare(b.domain),
      render(name) {
        return <StyledCol>{name}</StyledCol>
      }
    },
    {
      title: 'UREMEDIATE',
      dataIndex: 'uremediate',
      sorter: (a, b) => a.uremediate > b.uremediate,
      align: 'center',
      render(uremediate) {
        return uremediate ? <Icon type="check" /> : null
      }
    },
    {
      title: 'SSL',
      dataIndex: 'ssl',
      sorter: (a, b) => a.ssl > b.ssl,
      align: 'center',
      render(ssl) {
        return ssl ? <Icon type="check" /> : null
      }
    },
    {
      title: 'CREATED',
      dataIndex: 'created_on',
      sorter: (a, b) => moment(a.created_on).unix() - moment(b.created_on).unix(),
      render(created_on) {
        let now = moment()
        let created = moment(toLocalTime(created_on))
        let isNow = now.diff(created, 'minutes') < 1
        return <StyledDate>{isNow ? <span>now</span> : <TimeAgo date={toLocalTime(created_on)} live={false} />}</StyledDate>
      }
    },
    {
      key: 'edit',
      dataIndex: 'id',
      render(id, domain) {
        return (
          <Actions>
            <ActionsButtons>
              <Button type="link" onClick={() => onEdit(domain)}>
                EDIT
              </Button>
              <Button type="link" onClick={() => onDelete(id)}>
                DELETE
              </Button>
            </ActionsButtons>
          </Actions>
        )
      }
    }
  ]
}

export default DomainListColumns
